import { supabase } from "../supabase";
import type { Lesson } from "../types";

interface LessonRow {
  id: string;
  school_id: string;
  name: string;
  kind: "flight" | "ground";
  sort_order: number;
}

function mapLesson(r: LessonRow): Lesson {
  return {
    id: r.id,
    schoolId: r.school_id,
    name: r.name,
    kind: r.kind,
  };
}

export async function listBySchool(schoolId: string): Promise<Lesson[]> {
  const { data, error } = await supabase
    .from("lessons")
    .select("id, school_id, name, kind, sort_order")
    .eq("school_id", schoolId)
    .order("sort_order", { ascending: true });
  if (error) throw error;
  return (data as LessonRow[]).map(mapLesson);
}
